var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5991 17.0576H42.2763V19.3804H44.5991V17.0576Z",
    fill: "#4AA851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9537 12.412H23.6309V14.7348H25.9537V12.412Z",
    fill: "#4AA851"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6309 5.38074H21.3081V7.70357H23.6309V5.38074Z",
    fill: "#4AA851"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3081 7.76636H18.9852V10.0892H21.3081V7.76636Z",
    fill: "#4AA851"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9225 10.0892H16.5996V12.4121H18.9225V10.0892Z",
    fill: "#4AA851"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 12.412H14.2768V14.7348H16.5996V12.412Z",
    fill: "#4AA851"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2768 14.7349H11.954V17.0577H14.2768V14.7349Z",
    fill: "#4AA851"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.954 17.0576H9.63116V19.3804H11.954V17.0576Z",
    fill: "#4AA851"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63116 19.4432H7.30833V21.7661H9.63116V19.4432Z",
    fill: "#4AA851"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24554 21.7661H4.92271V24.0889H7.24554V21.7661Z",
    fill: "#4AA851"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9848 19.4433V21.7661V24.089V26.4118V28.7346V31.0574H49.3076V28.7346V26.4118V24.089V21.7661V19.4433V17.0577V14.7349H46.9848V17.0577V19.4433Z",
    fill: "#323232"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2763 31.0574H39.9535H37.6307H35.3078H32.985H30.5994H28.2766H25.9537V33.443H28.2766H30.5994H32.985H35.3078H37.6307H39.9535H42.2763H44.6619H46.9848V31.0574H44.6619H42.2763Z",
    fill: "#323232"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2766 14.7348H30.5994H32.985H35.3078H37.6307H39.9535H42.2763H44.6619H46.9848V12.412H44.6619H42.2763H39.9535H37.6307H35.3078H32.985H30.5994H28.2766H25.9537V14.7348H28.2766Z",
    fill: "#323232"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6309 35.7658V38.0887V40.4115V42.7343H25.9537V40.4115V38.0887V35.7658V33.443H23.6309V35.7658Z",
    fill: "#323232"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6309 7.7663V10.0891V12.412H25.9537V10.0891V7.7663V5.38069V3.05786H23.6309V5.38069V7.7663Z",
    fill: "#323232"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6309 42.7344H21.3081V45.0572H23.6309V42.7344Z",
    fill: "#323232"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6309 0.735107H21.3081V3.05794H23.6309V0.735107Z",
    fill: "#323232"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3081 40.4115H18.9852V42.7343H21.3081V40.4115Z",
    fill: "#323232"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3081 3.05786H18.9852V5.38069H21.3081V3.05786Z",
    fill: "#323232"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9225 38.0887H16.5996V40.4116H18.9225V38.0887Z",
    fill: "#323232"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9225 5.38074H16.5996V7.70357H18.9225V5.38074Z",
    fill: "#323232"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 35.7659H14.2768V38.0887H16.5996V35.7659Z",
    fill: "#323232"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 7.76636H14.2768V10.0892H16.5996V7.76636Z",
    fill: "#323232"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2768 33.443H11.954V35.7658H14.2768V33.443Z",
    fill: "#323232"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2768 10.0892H11.954V12.4121H14.2768V10.0892Z",
    fill: "#323232"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.954 31.0574H9.63116V33.3802H11.954V31.0574Z",
    fill: "#323232"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.954 12.412H9.63116V14.7348H11.954V12.412Z",
    fill: "#323232"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63116 28.7346H7.30833V31.0574H9.63116V28.7346Z",
    fill: "#323232"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63116 14.7349H7.30833V17.0577H9.63116V14.7349Z",
    fill: "#323232"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24554 26.4117H4.92271V28.7346H7.24554V26.4117Z",
    fill: "#323232"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24554 17.0576H4.92271V19.3804H7.24554V17.0576Z",
    fill: "#323232"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92273 24.089H2.5999V26.4118H4.92273V24.089Z",
    fill: "#323232"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92273 19.4432H2.5999V21.7661H4.92273V19.4432Z",
    fill: "#323232"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5999 21.7661H0.277069V24.0889H2.5999V21.7661Z",
    fill: "#323232"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6619 17.0576V19.4432V21.7661V24.0889V26.4117V28.7345H42.2763H39.9535H37.6307H35.3078H32.985H30.5994H28.2766H25.9537V31.0574H28.2766H30.5994H32.985H35.3078H37.6307H39.9535H42.2763H44.6619H46.9848V28.7345V26.4117V24.0889V21.7661V19.4432V17.0576H44.6619Z",
    fill: "#478443"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9537 31.0574H23.6309V33.3802H25.9537V31.0574Z",
    fill: "#478443"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3081 35.7658V38.0887V40.4115V42.7343H23.6309V40.4115V38.0887V35.7658V33.443H21.3081V35.7658Z",
    fill: "#478443"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9535 19.4433H37.6307H35.3078H32.985H30.5994H28.2766V17.0577H25.9537V14.7348H23.6309V12.412V10.0892V7.76636H21.3081V10.0892V12.412H18.9853V14.7348H16.5996V17.0577H14.2768V19.4433H11.954V21.7661H9.63116H7.30833V24.0889V26.4118H9.63116V28.7346H11.954V31.0574H14.2768V33.443H16.5996V35.7659H18.9853V33.443H21.3081V31.0574V28.7346H23.6309H25.9537V26.4118H28.2766H30.5994H32.985H35.3078H37.6307H39.9535H42.2763V24.0889V21.7661V19.4433H39.9535Z",
    fill: "#4AA851"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2763 19.4432V21.7661V24.0889V26.4117H39.9535H37.6307H35.3078H32.985H30.5994H28.2766H25.9537V28.7346H28.2766H30.5994H32.985H35.3078H37.6307H39.9535H42.2763H44.6619V26.4117V24.0889V21.7661V19.4432H42.2763Z",
    fill: "#4AA851"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3081 28.7346V31.0574V33.4431H23.6309V31.0574H25.9537V28.7346H23.6309H21.3081Z",
    fill: "#4AA851"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9852 35.7658H16.5996V38.0887H18.9852V40.4115H21.3081V38.0887V35.7658V33.443H18.9852V35.7658Z",
    fill: "#4AA851"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 33.443H14.2768V35.7658H16.5996V33.443Z",
    fill: "#4AA851"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2768 31.0574H11.954V33.3802H14.2768V31.0574Z",
    fill: "#4AA851"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M11.954 28.7346H9.63116V31.0574H11.954V28.7346Z",
    fill: "#4AA851"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63116 26.4117H7.30833V28.7346H9.63116V26.4117Z",
    fill: "#4AA851"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24554 24.089H4.92271V26.4118H7.24554V24.089Z",
    fill: "#4AA851"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6619 14.7349H42.2763H39.9535H37.6307H35.3078H32.985H30.5994H28.2766H25.9537V17.0577H28.2766H30.5994H32.985H35.3078H37.6307H39.9535H42.2763H44.6619H46.9848V14.7349H44.6619Z",
    fill: "#80E977"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6309 3.05786H21.3081V5.38069H23.6309V3.05786Z",
    fill: "#80E977"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3081 5.38074H18.9852V7.70357H21.3081V5.38074Z",
    fill: "#80E977"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9225 7.76636H16.5996V10.0892H18.9225V7.76636Z",
    fill: "#80E977"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 10.0892H14.2768V12.4121H16.5996V10.0892Z",
    fill: "#80E977"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2768 12.412H11.954V14.7348H14.2768V12.412Z",
    fill: "#80E977"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M11.954 14.7349H9.63116V17.0577H11.954V14.7349Z",
    fill: "#80E977"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63116 17.0576H7.30833V19.3804H9.63116V17.0576Z",
    fill: "#80E977"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24554 19.4432H4.92271V21.7661H7.24554V19.4432Z",
    fill: "#80E977"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92273 21.7661H2.5999V24.0889H4.92273V21.7661Z",
    fill: "#80E977"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9535 17.0576H37.6307H35.3078H32.985H30.5994H28.2766V19.4432H30.5994H32.985H35.3078H37.6307H39.9535H42.2763V17.0576H39.9535Z",
    fill: "#6BD063"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3081 10.0892H18.9852V12.4121H21.3081V10.0892Z",
    fill: "#6BD063"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9225 12.412H16.5996V14.7348H18.9225V12.412Z",
    fill: "#6BD063"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 14.7349H14.2768V17.0577H16.5996V14.7349Z",
    fill: "#6BD063"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2768 17.0576H11.954V19.3804H14.2768V17.0576Z",
    fill: "#6BD063"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.954 19.4432H9.63116V21.7661H11.954V19.4432Z",
    fill: "#6BD063"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.8621d1da4c696ea54540db4846ea3a98.svg";
export { ForwardRef as ReactComponent };